module.exports = __webpack_public_path__ + "static/pews.504b9d4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pews.jpg
// module id = 95
// module chunks = 35783957827783 82680274759079